import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ Footer
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Menu Tip

const TermsPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>📜 Terms of Service</h1>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />

        <p>
          Welcome to&nbsp;
          <strong>
            <span style={{ color: '#111827' }}>d</span>
            <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
            <span style={{ color: '#111827' }}>sy</span>
          </strong>. By using our app, you agree to the following:
        </p>

        <ul>
          <li>🌼 <strong>Your data is yours.</strong> We don’t sell it, share it, or sneak around with it.</li>
          <li>🧠 <strong>dAIsy remembers only for you.</strong> She’s here to support, not to collect.</li>
          <li>💬 <strong>Use the app with kindness.</strong> No abuse, hate, harassment, or harmful behavior — this is a space for care and trust.</li>
          <li>🚫 <strong>No sexually explicit or pornographic content.</strong> dAIsy is designed for thoughtful, respectful connection — not that kind of conversation.</li>
          <li>🛠️ <strong>This is a work in progress.</strong> We’re always improving — expect occasional changes and updates.</li>
        </ul>

        <ul>
          <li>✅ You’re responsible for your interactions and content.</li>
          <li>🔐 Your data is private and secure — we never sell your info.</li>
          <li>🚫 Abuse or misuse of the platform may result in account removal.</li>
          <li>📅 These terms may change, and continued use means you accept the updates.</li>
        </ul>

        <p className="mt-4">
          We’ve kept it short on purpose — no legalese. If you have questions, <strong>reach out anytime</strong>.
        </p>

        {/* Footer */}
        <FooterLinks />
      </div>
    </div>
  );
};

export default TermsPage;
